
import React, { useState, useEffect } from "react";
import "./AllPosts.css";
import { getAllPosts } from "../../api";
import { useNavigate } from "react-router-dom";

function AllPosts() {
    
    const [allPosts, setAllPosts] = useState([]);
    const [postChunkData, setPostChunkData] = useState([]);
    const navigate = useNavigate();
    
    const fetchAllPosts = async () => {
        const postsData = await getAllPosts();
        if (postsData.data) {
            const arr = new Array();
            for (let key in postsData.data) {
                let obj = {
                    day: key,
                    data: postsData.data[key],
                }
                arr.push(obj);
            }
            setAllPosts(arr);
        }
    }
    
    useEffect(() => {
        fetchAllPosts();
    }, []);

    const dateLook = (date) => {
        return new Date(date).toLocaleDateString("en-US",{
            month: "short", 
            day: "numeric", 
            year: "numeric",
        })
    }
    
    useEffect(() => {
        if (allPosts.length > 0) {
            setPostChunkData(allPosts);
        }
    }, [allPosts])
                                                
    const goToDayPage = (item) => {
        navigate('/day-posts', { state: item.data.posts });
    }
    
    return(
        <div className = "AllPosts">
            <div 
                className = "usersTableHeaderBox"  
                style = {{
                    width: "95%"
                }}
            >
                <h3 className = "usersTableHeaderText">
                    ALL POSTS
                </h3>
            </div>
            <div className = "allPostsDayGroupMainBox">
                {
                    postChunkData.map((item) =>
                        <div className="concretDayGroupBox"
                             key = { item.day }
                             onClick = { goToDayPage.bind(this, item) }
                        >
                            <span className="concretDayGroupCreatedDate">{ item.day }</span>
                            <span className="concretDayGroupPosts">{ item.data.posts.length } Posts</span>
                            <span className="concretDayGroupSuccess">{ item.data?.successPostsCount } Successful</span>
                            <span className="concretDayGroupFailed">{ item.data?.failedPostsCount } Failed</span>
                        </div>
                    )
                }
            </div>
        </div>
    )
}

export default AllPosts